import { render, staticRenderFns } from "./Internal-History-Detail.vue?vue&type=template&id=1719a248&scoped=true"
import script from "./Internal-History-Detail.vue?vue&type=script&lang=js"
export * from "./Internal-History-Detail.vue?vue&type=script&lang=js"
import style0 from "./Internal-History-Detail.vue?vue&type=style&index=0&id=1719a248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1719a248",
  null
  
)

export default component.exports